import { LanguagesDto } from "api/dtos/LanguagesDto";
import { USER_ROLES } from "../../constants/userPermissions";
import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";
import { LocationsDto } from "api/dtos/LocationsDto";

const registerFCMToken = (token) => {
  return axiosInstance.post(`${URLS.users}/devices/`, {
    registrationId: token,
    type: "web",
  });
};

// The backend has no unified "me" profile endpoint — only farmer/agronomist
// are covered. Other roles (sys_admin, le_admin, group_admin, ...) have no
// profile endpoint at all yet; callers must guard for that (see UserProvider).
const deleteMyAccount = (role) => {
  let userRole;
  if (role === USER_ROLES.FARMER) {
    userRole = "farmer";
  } else if (role === USER_ROLES.AGRONOMIST) {
    userRole = "agronomist";
  }
  if (!userRole) return undefined;

  return axiosInstance.delete(`${URLS.users}/${userRole}/profile/`);
};

const passwordRecovery = (payload) => {
  return axiosInstance.post(
    `${URLS.users}/password-recovery/request/`,
    payload
  );
};

const activateAccount = (payload) => {
  return axiosInstance.post(`${URLS.users}/activate-account/`, payload);
};

const changePassword = (payload) => {
  return axiosInstance.patch(`${URLS.users}/change-password/ `, payload, {});
};

const emailVerification = (payload) => {
  return axiosInstance.post(`${URLS.users}/send-email-verification/ `, payload);
};

const renewPassword = (payload) => {
  return axiosInstance.post(`${URLS.users}/password-recovery/renew/ `, payload);
};

const availableUserRegion = () => {
  return axiosInstance.get(`${URLS.users}/region/`);
};

// Unified profile endpoint — works for every role, not just farmer/agronomist.
const getProfile = () => {
  return axiosInstance.get(`${URLS.users}/profile/me/`);
};

const getMyProfile = (role) => {
  if (role === USER_ROLES.FARMER) {
    return axiosInstance.get(`${URLS.users}/farmer/profile/`);
  } else if (role === USER_ROLES.AGRONOMIST) {
    return axiosInstance.get(`${URLS.users}/agronomist/profile/`);
  }
  return undefined;
};

const editUserProfile = ({ data, role }) => {
  if (role === USER_ROLES.FARMER) {
    return axiosInstance.patch(`${URLS.users}/farmer/profile/`, data);
  } else if (role === USER_ROLES.AGRONOMIST) {
    return axiosInstance.patch(`${URLS.users}/agronomist/profile/`, data);
  }
  return undefined;
};

const getAvailableLanguages = async () => {
  try {
    const res = await axiosInstance.get(`${URLS.users}/language/`);
    const data = LanguagesDto.setup(res.data);
    return { ...res, data };
  } catch (error) {
    throw error;
  }
};
const getLocations = async () => {
  try {
    const res = await axiosInstance.get(`${URLS.search}/locations/`);
    const data = LocationsDto.setup(res.data);
    return { ...res, data };
  } catch (error) {
    throw error;
  }
};

export const accountApi = {
  activate: activateAccount,
  availableLanguages: getAvailableLanguages,
  availableLocations: getLocations,
  availableRegion: availableUserRegion,
  changePassword,
  delete: deleteMyAccount,
  emailVerification,
  fetch: getMyProfile,
  getProfile,
  passwordRecovery,
  registerFCMToken,
  renewPassword,
  update: editUserProfile,
};
